var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsxs, jsx } from "react/jsx-runtime";
import * as time from "d3-time";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTheme } from "styled-components";
import AxisLine from "./AxisLine.esm.js";
import AxisTicks from "./AxisTicks.esm.js";
import Label from "./Label.esm.js";
const YAxis = withTheme((_a = class extends Component {
  render() {
    const {
      yOrient,
      yAxisOffset,
      width,
      yAxisTickCount,
      yAxisTickInterval,
      yAxisClassName,
      stroke = this.props.theme.constellation.colors.textDark,
      yScale,
      margins,
      height,
      tickSize,
      tickFormatting,
      tickStroke = this.props.theme.constellation.colors.textDark,
      tickTextStroke,
      fontFamily
    } = this.props;
    const translate = `translate(${yAxisOffset + (yOrient === "right" ? width : 0)})`;
    let tickArguments;
    if (yAxisTickCount) {
      tickArguments = [yAxisTickCount];
    }
    if (yAxisTickInterval) {
      tickArguments = [time[yAxisTickInterval.unit], yAxisTickInterval.interval];
    }
    return /* @__PURE__ */ jsxs("g", { className: yAxisClassName, transform: translate, children: [
      /* @__PURE__ */ jsx(AxisTicks, { innerTickSize: tickSize, orient: yOrient, tickArguments, tickFormatting, tickStroke, tickTextStroke, scale: yScale, fontFamily }),
      /* @__PURE__ */ jsx(AxisLine, { orient: yOrient, outerTickSize: tickSize, scale: yScale, stroke, ...this.props }),
      /* @__PURE__ */ jsx(Label, { height, label: "", margins, orient: yOrient })
    ] });
  }
}, __publicField(_a, "propTypes", {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  tickStroke: PropTypes.string,
  width: PropTypes.number.isRequired,
  yAxisClassName: PropTypes.string,
  yAxisLabel: PropTypes.string,
  yAxisOffset: PropTypes.number,
  yAxisTickValues: PropTypes.array,
  yOrient: PropTypes.oneOf(["left", "right"]),
  yScale: PropTypes.func.isRequired,
  yAxisTickCount: PropTypes.number,
  yAxisTickInterval: PropTypes.number,
  height: PropTypes.number,
  tickSize: PropTypes.number,
  tickFormatting: PropTypes.func,
  tickTextStroke: PropTypes.string,
  fontFamily: PropTypes.string,
  margins: PropTypes.object,
  yAxisLabelOffset: PropTypes.number,
  theme: PropTypes.object
}), __publicField(_a, "defaultProps", {
  fill: "none",
  strokeWidth: "1",
  yAxisClassName: "rd3-y-axis",
  yAxisOffset: 0,
  yOrient: "left"
}), _a));
export {
  YAxis as default
};
